<template>
    <div class="chinaMap"></div>
</template>

<script>
import request from '@/utils/request'

const api = request
import "@/lib/china.js";

export default {
    name: "ChinaMap",
    data() {
        return {
            myChart: null,
            mapData: []
        };
    },
    methods: {
        async fetchData() {
            try {
                const response = await api.get('/api/chinaMap/getall');
                this.mapData = response.data;
                this.setMap();
            } catch (error) {
                console.error("数据加载失败:", error);
            }
        },
        setMap() {
            if (!this.mapData.length) return;

            // 将后端返回的数据转换为 ECharts 需要的格式
            const data = this.mapData.map(item => ({
                name: item.name,
                value: item.area
            }));

            const regions = data.map(item => ({
                name: item.name,
                itemStyle: { areaColor: "#2043AA" },
                emphasis: { itemStyle: { areaColor: "#2043AA" } }
            }));

            let option = {
                title: {
                    text: "全国水产养殖各省水产养殖面积",
                    subtext: "单位：亩",
                    x: "center",
                    textStyle: { color: "#6dd0e3", fontSize: 18, fontWeight: "bold" },
                    subtextStyle: { color: "#6dd0e3", fontSize: 13, fontWeight: "normal" }
                },
                visualMap: {
                    left: "right",
                    type: "piecewise",
                    pieces: [
                        { gte: 0, lte: 9999, label: "0-9,999", color: "#ADD8E6" },
                        { gte: 10000, lte: 49999, label: "10,000-49,999", color: "#00BFFF" },
                        { gte: 50000, lte: 99999, label: "50,000-99,999", color: "#1E90FF" },
                        { gte: 100000, lte: 499999, label: "100,000-499,999", color: "#0000CD" },
                        { gte: 500000, label: "500,000+", color: "#000080" }
                    ],
                    showLabel: true,
                    textStyle: { color: "#6dd0e3", fontSize: 10 }
                },
                tooltip: {
                    show: true,
                    backgroundColor: "#11367a",
                    textStyle: { color: "#6dd0e3", fontSize: 10 }
                },
                geo: {
                    map: "china",
                    top: "8%",
                    label: { show: true, color: "#6dd0e3", fontSize: 10 },
                    roam: true,
                    itemStyle: { areaColor: "#2043AA", borderColor: "#676e6f" },
                    regions: regions
                },
                series: [
                    {
                        name: "水产养殖面积",
                        type: "map",
                        geoIndex: 0,
                        data: data
                    }
                ]
            };

            if (!this.myChart) this.myChart = this.$echarts(this.$el);
            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>

<style lang="less" scoped>
.chinaMap {
    height: 100%;
}
</style>
